module.exports = __webpack_public_path__ + "img/create.bb3a5e09.svg";